<template>
  <badge :loading="false" :type="statusType" :text="statusText"></badge>
</template>


<script>
import Badge from '@/components/Badge';

export default {
  props: ['status'],

  components: { Badge },

  data() {
    return {
      statusTypes: {
        open: {
          type: 'warning',
          text: 'Offen',
        },
        completed: {
          type: 'success',
          text: 'Erfolgreich',
        },
        refunded: {
          type: 'danger',
          text: 'Rückerstattet',
        },
        partially_refunded: {
          type: 'warning',
          text: 'Teilweise Rückerstattet',
        },
        cancelled: {
          type: 'default',
          text: 'Abgebrochen',
        },
      },
      statusType: '',
      statusText: '',
    };
  },

  created() {
    this.statusType = this.statusTypes[this.status].type;
    this.statusText = this.statusTypes[this.status].text;
  },
};
</script>
